// Ionic & Angular Imports
import {Component} from '@angular/core';
//import {DatePipe } from '@angular/common';
import {NavController, NavParams, Loading, LoadingController, Refresher } from 'ionic-angular';
import {AlertController } from 'ionic-angular';

// Components 
import { BasePage } from '../base.component';
import { ReportPage } from '../report/report.component';

// Services
import {rsReportSvc} from '../../services/report.service';
import {rsProjectSvc, IProject} from '../../services/project.service';

@Component({
    templateUrl: 'create-report.html',
})
export class CreateReportPage extends BasePage 
{
    private contentList : IProject[] = undefined; 

    constructor( 
        protected alertCtrl : AlertController,
        private loadingCtrl : LoadingController,
        private navCtrl : NavController, 
        private navParams : NavParams,    
        private projectSvc : rsProjectSvc,
        private reportSvc : rsReportSvc
    ) {
        // Construct base class
        super( alertCtrl );

        // Retrieve the report list from NavParams
        this.contentList = this.navParams.get('projectList');
        this.sortContentList();
    }

    // Sorting method for ensuring our ContentList is always sorted by jobnumber (ie., oldest to newest entries)
    private sortContentList(reverse : boolean = false) {
        this.contentList.sort( (a,b) => {
            return reverse ? b.jobnumber - a.jobnumber : a.jobnumber - b.jobnumber;
        });
    }

    // Class method used by the template to refresh the ContentList
    public refreshContent( refresher : Refresher ) {
        // Spawn a spinner while the ContentList is being refreshed
        let loader : Loading = this.loadingCtrl.create( {
            content: 'Refreshing...'
        });
        loader.present().then( () => {
            // The spinner is loaded, so let's get our refreshed ContentList
            this.projectSvc.getProjects()
            .subscribe( result => {
                // Data was received from our service 
                this.contentList = result;
                this.sortContentList();
            }, err => {
                // The operation failed, so let's handle this error 
                loader.dismiss().then( () => {
                    this.displayError( "There was an error refreshing the list.  Please try again later." ).then( () => {
                        refresher.complete();
                    });
                });
            }, () => {
                // The operation succeeded, let's dismiss our spinner and complete our refresh operation 
                loader.dismiss().then( () => {
                    refresher.complete();
                });
            });
        });
    }

    // Class method used by the template to select a report from the ContentList
    public selectContent( project : IProject ) {
        // Verify that we have a valid project id before trying to continue
        if( project.id > 0 )
        {
            // Create our date string
            //let datePipe : DatePipe = new DatePipe("en-US");
            //let dateString = datePipe.transform( new Date(), 'fullDate' );
            let dateString = "Today"; 
            // ProjectID was valid; instantiate a creation confirmation 
            this.displayConfirmation( 'Create Report', 
                'Are you sure you want to create a new daily field report for the following project?' +
                '<br><br>' +
                '<div><strong>' + project.name + '</strong></div>' +
                '<div>' + dateString + '</div>', () => {
                // User confirmed - so let's initiate the creation process
                let loader : Loading = this.loadingCtrl.create( {
                    content: 'Loading...',
                });                            

                loader.present().then( () => {
                    // Start the creation process
                    this.reportSvc.createReport(project.id, true, true).subscribe( result => {
                        // Operation was successful, so let's navigate forward with our report                  
                    }, err => {
                        // // Operation failed- potentially because a report already exists
                        let errorCode : number = err.json().code;
                        let errMsg : string = "An error has occurred.  Please try again later.";
                        if( errorCode === 400 ) errMsg = "A report for this project has already been created.  Please try again later.";                                            
                        
                        // Hide the spinner and display our error message
                        loader.dismiss().then( () => { 
                             // Display our error message
                             this.displayError( errMsg );
                        });
                    }, () => {
                        this.navCtrl.push( ReportPage, {
                            animate: true, direction: 'forward'
                        }).then( () => {
                            loader.dismiss();
                        })
                    });
                });
            });
        } else {
            // The project id supplied is no valid; display a generic error
            this.displayError( 'An error has ocurred.  Please try again later.' );
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/create-report/create-report.component.ts